/**
 * UI elements
 */
class MP_UI {
  constructor() {
    this.initSmoothScroll();
    this.detectEdge();
    this.show360Popup();
  }

  initSmoothScroll () {
    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 100
          }, 1000);
        }
      }
    });
  }

  detectEdge () {
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
      document.body.classList.add('browser--is-edge')
    }
  }

  show360Popup () {
    let links = $('.show-360-popup a');

    if (!links.length) {
      return;
    }

    links.on('click', e => {
      e.preventDefault();
      let url = $(e.target).attr('href');
      this.openIframePopup(url);
    });
  }

  openIframePopup (url) {
    let popup = $('<div class="iframe-360-popup"><iframe src=""></iframe><a href="#close"><span>&times;</span></a></div>');
    popup.find('iframe').attr('src', url);
    popup.appendTo(document.body);

    setTimeout(() => {
      popup.addClass('is-active');
    }, 0);
    

    popup.find('a[href="#close"]').on('click', e => {
      e.preventDefault();
      this.closeIframePopup();
    });
  }

  closeIframePopup () {
    let popup = $('.iframe-360-popup');

    if (!popup.length) {
      return;
    }

    popup.removeClass('is-active');

    setTimeout(() => {
      popup.remove();
    }, 400);
  }
}
